import {
  BaSeGrid,
  BaSeInput,
  BaSeButton,
  BaSeGridItem,
  BaSeHeading5,
  BaSeHeading6,
  BaSeOptionPicker,
} from "@base/react";
import { Formik, Form } from "formik";
import TipBlock from "../../../components/tip-block";
import useTutorial from "../../../hooks/useTutorial";
import logoFampe from "../../../assets/images/fampe.png";
import FampeInputRange from "../../../components/fampe-input-range";
import GreenStatus from "../../../assets/images/fampe-green-status.png";

const TutorialGuarantees = () => {
  useTutorial({
    currentStep: "16",
    pageKey: "garantias",
    previousKey: "fluxoCaixaProjetado",
    steps: [
      {
        element: ".guarantees",
        popover: {
          title: "Garantias",
          description: `Garanta melhores condições de financiamento com o FAMPE! Utilize o fundo de aval do Sebrae para
          complementar as garantias exigidas pelo banco e facilitar o acesso ao crédito para seu negócio.`,
          side: "bottom",
          align: "center",
        },
      },
    ],
    onNextButtonClick: (driverObj, navigate) => {
      const tutorials = JSON.parse(localStorage.getItem("tutorials")) || {};
      tutorials["garantias"] = { ...tutorials["garantias"], finalizado: true };
      localStorage.setItem("tutorials", JSON.stringify(tutorials));

      localStorage.setItem("showFinalTutorial", "true");
      navigate("/meus-planejamentos");
      driverObj.drive(0);
    },
  });

  return (
    <div className="step guarantees">
      <BaSeHeading5
        color="#005EB8"
        fontFamily="Alegreya Sans"
        isBold
        className="mt-0"
      >
        FAMPE
      </BaSeHeading5>
      <BaSeGrid>
        <BaSeGridItem
          desktop={{
            size: 9,
            startAt: undefined,
          }}
          desktopLarge={{
            size: 8,
            startAt: undefined,
          }}
        >
          <p>
            O FAMPE é o fundo de aval do Sebrae que existe para te ajudar a
            completar o valor exigido pelo banco como garantia para o
            financiamento pretendido.
          </p>
          <p>
            Verifique os Limites de Garantia do FAMPE por Porte e Modalidade e
            conheça mais sobre o FAMPE no Portal Sebrae.
          </p>

          <Formik>
            {() => (
              <Form>
                <div className="wrapper-select">
                  <BaSeOptionPicker
                    isDisabled
                    label="Porte da empresa"
                    values={[{ id: 1, label: "Pequena Empresa" }]}
                    enableSelectAll={false}
                    menuAlwaysIsOpen={false}
                    withFilterText={false}
                    emptyValueLabel="Selecione"
                    maxOptionsSelected={1}
                  />
                </div>
                <div className="group-input">
                  <BaSeGrid>
                    <BaSeGridItem
                      desktop={{
                        size: 6,
                        startAt: undefined,
                      }}
                    >
                      <BaSeInput
                        isDisabled
                        color="default"
                        inputMode="tel"
                        typeInput="tel"
                        placeholder="R$"
                        maxLength={22}
                        prefix="R$ "
                        mask="decimal"
                        size="medium"
                        label="Valor Financiamento"
                        width="100%"
                      />
                    </BaSeGridItem>
                    <BaSeGridItem
                      desktop={{
                        size: 6,
                        startAt: undefined,
                      }}
                    >
                      <BaSeInput
                        isDisabled
                        color="default"
                        inputMode="decimal"
                        typeInput="tel"
                        placeholder="R$"
                        maxLength={22}
                        prefix="R$ "
                        mask="decimal"
                        size="medium"
                        label="Valor garantias exigidas pelo banco"
                        width="100%"
                      />
                    </BaSeGridItem>
                  </BaSeGrid>
                </div>
                <div className="fampe-range">
                  <FampeInputRange
                    value={80}
                    setValue={() => {}}
                    label="Qual a porcentagem de garantia FAMPE você gostaria de calcular?"
                  />
                </div>
                <div
                  style={{
                    paddingBottom: "16px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <BaSeButton
                    onClick={() => {}}
                    isDisabled
                    value="Realizar Cálculo"
                    buttonType="button"
                    color="#005EB8"
                    isBold
                    rightIcon="refresh-alt"
                    size="small"
                    type="secondary"
                  />
                </div>
                <div>
                  <TipBlock
                    image={GreenStatus}
                    borderColor="linear-gradient(to top, #84F4BC, #E4F998)"
                  >
                    <BaSeHeading6>
                      <span
                        style={{
                          gap: "10px",
                          padding: "8px",
                          display: "flex",
                          textAlign: "left",
                          flexDirection: "column",
                        }}
                      >
                        <strong>
                          O limite padrão de garantias do FAMPE é de 80%.{" "}
                        </strong>
                        Você tem grandes chances de conseguir o aval com esse
                        valor.
                      </span>
                    </BaSeHeading6>
                  </TipBlock>
                </div>
                <div className="group-input inputs-blue border-none mb-0">
                  <BaSeGrid>
                    <BaSeGridItem
                      desktop={{
                        size: 6,
                        startAt: undefined,
                      }}
                    >
                      <div className={"input-error-message "}>
                        <BaSeInput
                          isDisabled
                          color="default"
                          inputMode="tel"
                          typeInput="tel"
                          placeholder="R$"
                          maxLength={22}
                          prefix="R$ "
                          mask="decimal"
                          size="medium"
                          label="Garantia Fampe"
                          width="100%"
                          isReadOnly={true}
                          showHelpButton
                        />
                      </div>
                    </BaSeGridItem>
                    <BaSeGridItem
                      desktop={{
                        size: 6,
                        startAt: undefined,
                      }}
                    >
                      <BaSeInput
                        isDisabled
                        color="default"
                        inputMode="tel"
                        typeInput="tel"
                        placeholder="R$"
                        maxLength={22}
                        prefix="R$ "
                        mask="decimal"
                        size="medium"
                        label="Complemento necessário de garantias"
                        width="100%"
                        isReadOnly={true}
                      />
                    </BaSeGridItem>
                  </BaSeGrid>
                </div>
              </Form>
            )}
          </Formik>
        </BaSeGridItem>
        <BaSeGridItem
          desktop={{
            size: 3,
            startAt: undefined,
          }}
          desktopLarge={{
            size: 4,
            startAt: undefined,
          }}
        >
          <div className="box-fampe">
            <p>
              Saiba mais sobre o FAMPE{" "}
              <a
                target="_blank"
                href="https://sebrae.com.br/sites/PortalSebrae/fampe"
                rel="noreferrer"
              >
                aqui
              </a>
            </p>
            <figure>
              <img src={logoFampe} alt="FAMPE" loading="lazy" />
            </figure>
          </div>
        </BaSeGridItem>
      </BaSeGrid>
    </div>
  );
};

export default TutorialGuarantees;
